import React from 'react';
import { useRouteData, useSiteData, Head } from 'react-static';
// template components
import ContentHub from '@nmx/template/dist/componentLibrary/modules/ContentHub';
import Page from '@nmx/template/dist/componentLibrary/layout/Page';
import Theme from '@nmx/template/dist/componentLibrary/Theme';
// native components
import ExperienceCallout from './components/experienceCallout';
import Faq from './components/faq';
import FinancialPlanningSection from './components/financialPlanningSection';
import HeroSection from './components/heroSection';
import IntroSection from './components/introSection';
import MailingSchedules from './components/mailingSchedules/mailingSchedules';
import Metadata from './components/metadata';
import TaxDocumentsBeingSent from './components/taxDocumentsBeingSent';
// images for prefetch
import highResDesktopImage from './components/heroSection/images/tax-documents-hero-desktop.webp';
import highResMobileImage from './components/heroSection/images/tax-documents-hero-mobile.webp';

export default () => {
  const { config, dynamicConfig } = useSiteData();
  const { pageProps, contentHubItems } = useRouteData();

  // get current year to inject into page description
  const getCurrentYear = () => {
    const date = new Date();
    return date.getFullYear();
  };

  const year = getCurrentYear();
  // update the page description with current year
  pageProps.pageDescription = `View or download your Northwestern Mutual tax documents for the ${year} tax year. See when you can expect to access the tax documents you need for filing.`;

  // creating a getter for this module so we can render it in more than one spot and with a unique ID
  const getExperienceCallout = (id) => {
    return <ExperienceCallout id={id} />;
  };

  return (
    <Page
      {...pageProps} // defined in route.js
      headComponent={Head}
      config={config}
      dynamicConfig={dynamicConfig}
      disableDisclaimerTopBorder
      breadcrumbsNavigationConfig={[
        {
          pageName: 'Home',
          linkUrl: '/',
          linkAriaLabel: 'Northwestern Mutual Home',
        },
        {
          pageName: 'Tax Documents',
          linkUrl: '/tax-documents/',
          linkAriaLabel: 'Northwestern Mutual Client Tax Documents',
        },
      ]}
      customDisclaimers={[
        <>
          This information is not intended as legal or tax advice. This information was compiled by Northwestern Mutual and is intended solely for the information and education of Northwestern Mutual&#39;s financial advisors and representatives, their customers, and the legal and tax advisors of those customers. It must not be used as a basis for legal or tax advice, and is not intended to be used and cannot be used to avoid any penalties that may be imposed on a taxpayer.
        </>,
        <>
          Northwestern Mutual and its financial representatives do not give legal or tax advice. Taxpayers should seek advice about their circumstances from an independent legal, accounting, or tax advisor. Tax and other planning developments after the original date of publication may affect these discussions.
        </>,
      ]}>
      <Head>
        {/* prefetch expensive images */}
        <link rel='preload' href={highResMobileImage} as='image' media={`(max-width: ${Theme.breakpoints.values.medium}px)`} />
        <link rel='preload' href={highResDesktopImage} as='image' media={`(min-width: ${Theme.breakpoints.values.medium + 1}px)`} />
      </Head>

      <Metadata
        image={highResDesktopImage}
        pageDescription={pageProps.pageDescription}
        pageTitle={pageProps.pageTitle}
      />

      <HeroSection />

      <IntroSection />

      <MailingSchedules />

      <FinancialPlanningSection />

      {getExperienceCallout('log-in-a')}

      <TaxDocumentsBeingSent />

      <Faq />

      {getExperienceCallout('log-in-b')}

      <ContentHub
        sectionId='content-hub'
        headingText='Boost your knowledge on taxes'
        contentHubItems={contentHubItems} // defined in route.js
        config={config}
      />

    </Page>
  );
};
